import * as actions from 'actions/HelpCentreActions/incidentActions';
import { LOADING, INIT, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
const { incidentActionsEnum } = actions;
const defaultState = {
    data: {},
    asyncStatus: INIT
};
export default function incidents(state = defaultState, action) {
    switch (action.type) {
        case incidentActionsEnum.SEND_INCIDENT_REQUEST:
            return Object.assign({}, state, {
                asyncStatus: LOADING
            });
        case incidentActionsEnum.SEND_INCIDENT_REQUEST_SUCCESS:
            return {
                data: action.data,
                asyncStatus: SUCCESS
            };
        case incidentActionsEnum.SEND_INCIDENT_REQUEST_ERROR:
            return Object.assign({}, state, {
                asyncStatus: ERROR,
                data: action.error
            });
        case incidentActionsEnum.RESET_INCIDENT_MODAL:
            return Object.assign({}, state, {
                asyncStatus: INIT,
                data: {}
            });
        default:
            return state;
    }
}
